import { instanceApi } from '../../../services';
import { ClientListEmailReportRequest } from './ClientListModel';

export const getClientsReport = (
  partnershipIds: number[],
  currency: string[],
  onlyDepositsWithdrawals: boolean,
  fromDate?: string,
  toDate?: string,
): Promise<any> =>
  instanceApi.post('api/AnalysisReport/partnersClientsReport', {
    currencies: currency,
    partnershipIds,
    onlyDepositsWithdrawals,
    fromDate,
    toDate,
  });

export const sendEmailClientsOverviewReport = (data: ClientListEmailReportRequest): Promise<any> => instanceApi.post('api/analysisreport/sendemailclientsoverviewreport', data);

export const checkClient = (emailOrTA: string | number): Promise<any> => instanceApi.get(`api/partners/partnership/client/${emailOrTA}/check-assignments`);
